/*
 * O tema da aplicação num só sítio.
 *
 * Havia três mecanismos a competir (e a discordar entre si): o cabeçalho escrevia `body.dark-mode` com a chave
 * `darkMode`, as Definições escreviam `data-theme` com a chave `isDarkMode` (e recarregavam a página), e o
 * ThemeProvider usava `:root.dark` com a chave `theme`. Resultado: ao ligar o modo escuro pelo cabeçalho, os
 * campos de formulário e os botões secundários ficavam com o fundo claro e o texto claro (contraste ~1,1:1).
 *
 * Agora há uma chave (`theme`) e uma função (`applyTheme`): escreve os três sinais que o CSS usa —
 * `:root.dark` + `data-theme` (tokens completos em styles/theme.css) e `body.dark-mode` (estilos de estrutura
 * do Layout.css: barra lateral, cabeçalho).
 */
export const THEME_KEY = 'theme';

export const readStoredTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY) === 'dark';
  } catch {
    return false;
  }
};

export const applyTheme = (isDark, { persist = true } = {}) => {
  const root = document.documentElement;
  root.classList.toggle('dark', isDark);
  root.setAttribute('data-theme', isDark ? 'dark' : 'light');
  document.body.classList.toggle('dark-mode', isDark);
  if (persist) {
    try {
      localStorage.setItem(THEME_KEY, isDark ? 'dark' : 'light');
    } catch {
      /* sem armazenamento: o tema vale só para esta sessão */
    }
  }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', isDark ? '#0f172a' : '#6366f1');
  return isDark;
};
